import { segmentString } from 'src/replicant/utils/string';
import TextInputView, { TextInputViewOpts } from './TextInputView';

type TextInputOpts = TextInputViewOpts & {
  minLength?: number;
  maxLength?: number;
  placeholder?: string;
  value?: string;
};

export class TextInput extends TextInputView {
  protected get placeholder() {
    return this._placeholder;
  }
  protected set placeholder(value: string) {
    this._placeholder = value;
    if (!this.input) return;
    this.input.placeholder = this._placeholder;
  }
  protected _placeholder: string;

  protected minLength: number;
  protected maxLength: number;
  protected validInput: boolean;

  constructor(opts: TextInputOpts) {
    super(opts);

    this.placeholder = opts.placeholder ?? '';
    this.minLength = opts.minLength ?? 0;
    this.maxLength = opts.maxLength ?? Number.POSITIVE_INFINITY;

    // Attach validator only when view is added to hierarchy.
    const validate = this.validate.bind(this);
    this.on('ViewAdded', () => {
      // Make sure placeholder is set.
      this.input.placeholder = this._placeholder;
      this.input.addEventListener('input', validate);
    });
    this.on('ViewRemoved', () => {
      this.input.removeEventListener('input', validate);
    });
  }

  public updateOpts(opts: TextInputOpts) {
    super.updateOpts(opts);

    this.minLength = opts.minLength ?? this.minLength;
    this.maxLength = opts.maxLength ?? this.maxLength;
    this.placeholder = opts.placeholder ?? this.placeholder;

    this.validate();

    return opts;
  }

  private validate() {
    // Run validator.
    this.runValidator();
    // Always emit event.
    this.emit('InputValidated', this.validInput);
  }

  protected runValidator() {
    const segmented = segmentString(this.input.value);

    // Non fixable case. Bail and set validInput to false.
    if (segmented.length < this.minLength) {
      this.validInput = false;
      return;
    }

    // Fixable case. Apply fix and set validInput to true.
    this.validInput = true;
    if (segmented.length <= this.maxLength) {
      return;
    }
    this.input.value = segmented.slice(0, this.maxLength).join('');
  }
}
